import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import envStatic from '../../../envStatic';
import { BIRender } from '../../components/PowerBIRender/BIRender';
import { getUserFactoryId, getStructureTree } from '../../../index';
import { recursiveGetElementsByName, recursiveGetElements, recursiveGetIds, parse } from '../../helpers/three';

export default function IdcardRelatorio(props)
{
    const userFactory = parseInt(getUserFactoryId());
    const routeParams = useParams();

    console.log(routeParams)
    const option = routeParams.option;    
    const filter = routeParams.filter;
    const [ids, setIds] = useState([]);

    useEffect(() => {
        const init = async (filter) => {

            const structureTreeApi = await getStructureTree();

            var structuresNames = filter.replace('\'', '').replace(/'/g, '').split(",");
            var tempIds = []
            for (var i = 0; i < structuresNames.length; i++) {
                const selectedNodes = recursiveGetElementsByName(structuresNames[i].replace(`'`, ''), structureTreeApi.structures, []);
                const departments = recursiveGetElements(selectedNodes, []);
                const newIds = recursiveGetIds(selectedNodes, []);
                newIds.forEach(id => tempIds.push(id));
            }
            console.log(`ids`, tempIds)
            setIds(tempIds);
            /*const formattedStructureTree = prepareData(structureTreeApi.structures, historyApi)

            console.log(formattedStructureTree)

            setTree(formattedStructureTree);*/
        }
        var filters = filter == 'null' ? '' : filter;
        if (filters != '' && option == 2)
            init(filters.replace(`'`, ''));
    }, []);

    return (
        <BIRender
            filters={`&filter=factories/id eq ${userFactory}` + ((option == 1 || ids.length == 0) ? '' : ` and structures/id in (${ids})`)}
            reportSection={option == 2 ? envStatic.reportSectionIDCardGrafico : envStatic.reportSectionIDCard}
        />)
}
